"use strict";

require("core-js/modules/web.dom.iterable");

require("core-js/modules/es6.array.iterator");

require("core-js/modules/es6.object.to-string");

require("core-js/modules/es6.object.keys");

require("core-js/modules/es6.array.find");

require("core-js/modules/es6.object.assign");

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _box = _interopRequireDefault(require("@waglabs/box"));

var _label = _interopRequireDefault(require("@waglabs/label"));

var _ = require("..");

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}

function _extends() {
  _extends = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };

  return _extends.apply(this, arguments);
}

var SelectField = function SelectField(_ref) {
  var dataTestId = _ref.dataTestId,
      error = _ref.error,
      isSearchable = _ref.isSearchable,
      label = _ref.label,
      onBlur = _ref.onBlur,
      onChange = _ref.onChange,
      onFocus = _ref.onFocus,
      options = _ref.options,
      placeholder = _ref.placeholder,
      value = _ref.value,
      props = _objectWithoutPropertiesLoose(_ref, ["dataTestId", "error", "isSearchable", "label", "onBlur", "onChange", "onFocus", "options", "placeholder", "value"]);

  return _react.default.createElement(_box.default, {
    width: "100%",
    position: "relative"
  }, label && _react.default.createElement(_label.default, null, label), _react.default.createElement(_.Select, _extends({
    bg: "backgroundGray",
    border: 0,
    borderRadius: 3,
    boxShadow: "none",
    color: "medGray",
    "data-testid": dataTestId,
    error: error,
    fontFamily: "body",
    fontSize: 4,
    height: 50,
    isSearchable: isSearchable,
    onBlur: onBlur,
    onChange: onChange,
    onFocus: onFocus,
    options: options,
    placeholder: placeholder,
    textIndent: "10px",
    value: options && options.find(function (option) {
      return value === option.value;
    }),
    width: 1
  }, props)));
};

SelectField.defaultProps = {
  isSearchable: true,
  options: []
};
var _default = SelectField;
exports.default = _default;